<template>
  <div class="landing-page">
    <div class="landing-page__info">
      <Left />
      <Right class="ml15" />
    </div>
  </div>
</template>
<script>
import Left from '@/components/main/Left';
import Right from '@/components/main/Right';

export default {
  components: {
    Left,
    Right,
  },
  setup() {
    
  },
}
</script>
<style lang="scss" scoped>
  .landing-page {
    display: flex;
    
    &__info {
      display: flex;
      margin-top: 15px;
      margin-bottom: 30px;
      gap: 24px;

      .ml15 {
        margin-left: 0;
      }
    }

    /* Add intermediate breakpoint */
    @media (min-width: 769px) and (max-width: 1024px) {
      &__info {
        gap: 20px;
      }
    }
    
    @media (max-width: $tabletSize) {
      &__info {
        flex-direction: column;
        width: 100%;
        gap: 15px;

        .ml15 {
          margin-left: 0;
        }
      }
    }
  }
</style>
